import styled from "styled-components";
export const StudyManagerBannerParent = styled.div `
    & > div {
        padding: 16px 80px;
    }
`;
